// extracted by mini-css-extract-plugin
module.exports = {"container":"partials-paginator-container","button":"partials-paginator-button","current":"partials-paginator-current"};